<template>
  <div class="container">
    <div class="filter-container">
<!--      <el-button-->
<!--          class="filter-item"-->
<!--          type="primary"-->
<!--          size="mini"-->
<!--          icon="el-icon-plus"-->
<!--          style="margin-bottom:10px"-->
<!--          @click="handleCreate"-->
<!--      >添加</el-button>-->
      <el-select
          v-model="searchType"
          placeholder="请选择"
          style="width: 120px; margin-right: 10px;"
          size="small"
          class="filter-item"
      >
        <el-option label="标题" value="StrPositiveTitle"></el-option>
        <el-option label="条码" value="StrBookBarcode"></el-option>
<!--        <el-option label="书架" value="StrBookshelfName"></el-option>-->
<!--        <el-option label="馆藏名称" value="StrLibraryName"></el-option>-->
        <el-option label="创建人" value="StrCreatorName"></el-option>
      </el-select>
      <el-input
          v-model="searchValue"
          placeholder="请输入搜索内容"
          style="width: 200px; margin-right: 10px;"
          class="filter-item"
          size="small"
          @keyup.enter.native="handleFilter"
      />
      <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleFilter"
      >搜索</el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="标题" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrPositiveTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column label="条码" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrBookBarcode }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="馆藏名称" align="center">-->
<!--        <template v-slot="{row}">-->
<!--          <span>{{ row.StrLibraryName }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="书架" align="center">-->
<!--        <template v-slot="{row}">-->
<!--          <span>{{ row.StrBookshelfName }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->

      <el-table-column label="剔旧时间" align="center">
        <template v-slot="{row}">
          <span>{{ formatDate(row.DTOldDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="出版社" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrPublisher }}</span>
        </template>
      </el-table-column>
      <el-table-column label="第一责任人" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrFirstResponsible }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="是否在架" align="center">-->
<!--        <template v-slot="{row}">-->
<!--          <span>{{ row.OnShelf ? '在架' : '不在架' }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="创建人" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrCreatorName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="价格" align="center">
        <template v-slot="{row}">
          <span>{{ row.FloatPricePer }} (元)</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          fixed="right"
          width="230px"
      >
        <template v-slot="{row}">
          <el-button type="success" size="mini" @click="revoke(row)">撤 销</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top:50px;text-align:right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>

  </div>
</template>

<script>
import {BASE_URL} from "@/utils/constants";
export default {
  name:'bookshelf',
  data() {
    return {
      list: null,
      total: 0,
      listQuery: {
        Page: 1,
        Perpage: 10,
        Search: {}, // 将 Search 定义为空对象
      },
      // 新增：用于搜索类型和搜索值的两个变量
      searchType: 'StrPositiveTitle', // 默认搜索类型为标题
      searchValue: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    revoke(row)
    {
      console.log(row.StrPositiveTitle);
      const params = {
        StrID: row.StrID,
      }
      this.$confirm(`确定撤销《${row.StrPositiveTitle}》吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          url: BASE_URL + "books/canceloldbooks",
          method: "post",
          data:params,
          //发送格式为json
          headers: {
            "Content-Type": "application/json",
            dataType: "json",
            Authorization: localStorage.getItem("token"),
          },
        }).then((res) => {
          if (res.data.ok) {
            this.$notify({
              message: "撤销成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              message: res.data.msg,
              type: "error",
              duration: 5000,
            });
          }
          this.getList();
        });
      });
    },
    // 获取书架列表
    getList() {
      // 调整：动态构建 Search 对象
      const params = {
        Page: this.listQuery.Page,
        Perpage: this.listQuery.Perpage,
      };

      // 只有当 searchValue 不为空时，才将搜索参数添加到 Search 对象中
      if (this.searchValue) {
        params.Search = {}; // Initialize Search object
        params.Search[this.searchType] = this.searchValue;
      }

      this.$axios({
        url: BASE_URL + 'books/oldbooks',
        method: 'post',
        data: JSON.stringify(params), // 发送动态构建的参数
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg
          this.total = res.data.total
        }
      })
    },
    // 新增：处理搜索的方法
    handleFilter() {
      // 当执行搜索时，将当前页码重置为第一页
      this.listQuery.Page = 1;
      // 调用获取列表的方法，传入搜索参数
      this.getList();
    },
    // 新增的日期格式化方法
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage
      this.getList()
    },
    currPageChange(Page) {
      this.listQuery.Page = Page
      this.getList()
    }
  }
}

</script>

